// src/pages/ForgotPassword.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import ConfirmModal from "../components/ConfirmModal";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy,  setBusy]  = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/forgot-password", { email });
      setShowModal(true);                // open success modal
    } catch (err) {
      console.error(err);
      setError("Sorry – server error. Try again in a bit.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="max-w-md mx-auto mt-24 p-6 bg-white rounded-xl shadow">
      <h1 className="text-2xl font-bold mb-6 text-center">Forgot password</h1>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          required
          placeholder="Your e‑mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-4 p-3 border rounded bg-white text-black placeholder-gray-500"
        />

        <button
          type="submit"
          disabled={busy}
          className={`w-full p-3 rounded text-white font-semibold ${
            busy ? "bg-gray-400" : "bg-amber-500 hover:bg-amber-600"
          }`}
        >
          {busy ? "Sending…" : "Send reset link"}
        </button>
      </form>

      {error && <p className="text-red-500 mt-4 text-sm">{error}</p>}

      <p className="mt-6 text-sm text-center">
        Remembered your password?&nbsp;
        <Link to="/login" className="text-blue-600 hover:underline">
          Back to login
        </Link>
      </p>

      {/* one‑button info modal */}
      <ConfirmModal
        isOpen={showModal}
        title="Check your e‑mail"
        message="If an account exists for that e-mail, a password reset link has been sent."
        confirmText="OK"
        hideCancel
        onConfirm={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
}
